/* istanbul ignore file */
/**
 * noOp - no operation
 * https://en.wikipedia.org/wiki/NOP_(code)
 * Used as a placeholder function that does nothing.
 */

/* eslint-disable @typescript-eslint/no-empty-function */
export const noOp = (): void => {};
